import * as React from 'react';
import { Tooltip, ActionIcon, createStyles } from '@mantine/core';
import { IconHelp } from '@tabler/icons-react';

// Hooks
import { useFieldTranslation } from '../Form/hooks/useFieldTranslation';

const useStyles = createStyles((theme) => ({
    inline: {
        display: 'inline-block'
    }
}));
interface HelpTooltipButtonProps {
    labelKey?: string;
    translationNamespace?: string;
    inline?: boolean;
}

export const HelpTooltipButton: React.FC<HelpTooltipButtonProps> = ({
    labelKey,
    translationNamespace,
    inline,
    ...props
}) => {
    const { classes, cx } = useStyles();
    const tooltipLabel = useFieldTranslation({ key: labelKey, translationNamespace });

    return (
        <Tooltip
            label={tooltipLabel}
            withArrow
            width={300}
            multiline
            className={cx('', {
                [classes.inline]: inline
            })}
        >
            <ActionIcon color="blue">
                <IconHelp size="1rem" />
            </ActionIcon>
        </Tooltip>
    );
};
